/**
 * Text made safe to place inside an HTML string (#406).
 *
 * Leaflet's DivIcon takes raw HTML, so React's escaping does not reach it. A
 * drone's name is typed by a pilot and shown on every other viewer's map: an
 * admin's, and every pilot's for an unclaimed drone. Unescaped, a name is
 * markup that runs in their browser.
 *
 * Quotes too, because names also land in attribute values (`aria-label`).
 */
export const escapeHtml = (text: string): string =>
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
